/**
 * A small button naming a node of a suggestion: a click selects it and centres the graph on it.
 */
import type { JSX } from "solid-js";
import { useApp } from "../../app/context";
import { Dot } from "../../shared/ui";

/** The chip of node `id` (its name from the graph, else `name`, else the id: a node not made yet or gone). */
export function NodeChip(props: { id: string; name?: string }): JSX.Element {
  const { graph, view } = useApp();
  const node = () => graph.state.graph.nodes.find((n) => n.id === props.id);
  return (
    <button
      type="button"
      class="ai-chip"
      data-ai-node={props.id}
      title={props.id}
      onClick={() => {
        view.selectNode(props.id);
        view.requestCenter(props.id);
      }}
    >
      {node() && <Dot node={node()!} />}
      <span>{node()?.name ?? props.name ?? props.id}</span>
    </button>
  );
}
